import React from 'react';
import { ArrowLeft, Clock } from 'lucide-react';

export const TimelineHeader = ({ onBack, surveyName }) => {
  return (
    <div className="sticky top-0 bg-[#2A2B2E] shadow-sm z-10 p-4 border-b border-gray-700">
      <div className="flex items-center gap-4">
        <button
          onClick={onBack}
          className="p-2 hover:bg-gray-700 rounded-lg"
        >
          <ArrowLeft className="w-6 h-6 text-white" />
        </button>
        <div className="flex-1 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <Clock className="w-6 h-6 text-blue-500" />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-white">Route Timeline</h1>
              <p className="text-sm text-gray-400">
                {surveyName || 'No survey selected'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};